import * as rq from '@tanstack/react-query';

import { IWarrantyRepository } from '@/warranty/domain/repositories/warranty.repository';

import { useDependencies } from '../contexts/dependencies.context';

export namespace GetAllWarrantyIDStatus {
  export const key = (input: Input, repository: IWarrantyRepository) => [
    'warranty',
    'get-all-warranty-id-status',
    repository.key,
    input.filters,
    input.assetFullFrontendId,
  ];

  export type Params = { refetchInterval?: number };
  export type Input = IWarrantyRepository.GetAllWarrantyIDStatusInput;
  export type Output = IWarrantyRepository.GetAllWarrantyIDStatusOutput;

  export function useQuery(input: Input, { refetchInterval }: Params = {}) {
    const { repositories } = useDependencies();

    return rq.useQuery<Output>({
      refetchInterval,
      queryKey: key(input, repositories.warranty),
      queryFn: () => repositories.warranty.getAllWarrantyIDStatus(input),
    });
  }
}
